import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { GlobalUserInfo } from 'src/app/app.model';

@Component({
  selector: 'app-header-navbar',
  templateUrl: './header-navbar.component.html',
  styleUrls: ['./header-navbar.component.scss'],
})
export class HeaderNavbarComponent implements OnInit, OnDestroy {
  @Input() sidenav: MatSidenav;
  @Input() userInfo: GlobalUserInfo;
  @Input() mobileQuery: MediaQueryList;

  @Output() profileAction: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {
    // console.log(this.route.snapshot.url);
    // console.log(window.location.href);
  }

  ngOnDestroy(): void {}

  onProfileAction(event: string): void {
    this.profileAction.emit(event);
  }
}
